import React from 'react';

const BackArrowIcon = ({ className = 'w-5 h-5' }) => {
  return (
    <svg
      className='w-5 h-5'
      xmlns='http://www.w3.org/2000/svg'
      shapeRendering='geometricPrecision'
      textRendering='geometricPrecision'
      imageRendering='optimizeQuality'
      fillRule='evenodd'
      clipRule='evenodd'
      viewBox='0 0 512 404.43'
    >
      <path
        fillRule='nonzero'
        d='m68.69 184.48 443.31.55v34.98l-438.96-.54 173.67 159.15-23.6 25.79L0 199.94 218.6.02l23.6 25.79z'
      />
    </svg>
  );
};

export default BackArrowIcon;
